import makeAssimilator from '../store/make-assimilator';

const assimilateMasterGain = makeAssimilator('masterGain');

export default assimilateMasterGain;
